var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconsZoomOut = function SvgIconsZoomOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.012 2c4.978 0 9.013 4.035 9.013 9.012 0 2.089-.71 4.011-1.903 5.54l3.553 3.551c.433.434.433 1.138 0 1.572-.401.4-1.031.43-1.467.092l-.105-.092-3.552-3.553c-1.528 1.192-3.45 1.903-5.539 1.903C6.035 20.025 2 15.99 2 11.012 2 6.035 6.035 2 11.012 2zm0 2.222c-3.75 0-6.79 3.04-6.79 6.79s3.04 6.79 6.79 6.79c1.832 0 3.493-.724 4.715-1.903.023-.032.05-.063.08-.092l.092-.08c1.179-1.222 1.903-2.883 1.903-4.715 0-3.75-3.04-6.79-6.79-6.79zm2.963 5.68c.614 0 1.111.497 1.111 1.11 0 .57-.429 1.04-.981 1.104l-.13.007H8.05c-.613 0-1.11-.497-1.11-1.11 0-.57.428-1.04.98-1.104l.13-.008h5.926z"
  })));
};
export default SvgIconsZoomOut;